import { Toast } from "antd-mobile";
import { omitBy } from "lodash";
import r from "modules/Request";
// 判断一个函数是否是一个 Promise 函数
const isPromiseFn = (fn) => fn instanceof Promise;

/**
 * 将一个函数转换为 Promise 函数
 *
 * @param {*} pro promise
 * @returns [res,err] 返回函数的执行结果和错误信息
 */
export const to = async (pro) => {
  try {
    // 如果函数不是一个 Promise 函数，则抛出异常
    if (!isPromiseFn(pro)) throw new Error("fn must be a Promise function");
    return [await pro, null];
  } catch (err) {
    return [null, err];
  }
};

/**
 * 业务To asyncTo 函数
 * @param {*} promise promise
 * @returns [res, err]
 */
export const businessTo = async (promise) => {
  return promise
    .then((res) => {
      const code = res?.status?.code;
      if (code !== "00000") {
        const errText = res?.status?.msg;
        Toast.show({
          content: errText || "系统繁忙，请稍后重试",
        });
        return null;
      }
      const result = res?.data;
      return result;
    })
    .catch(() => {
      return null;
    });
};

/**
 * 为空默认值
 * @param {*} text
 * @returns
 */
export const emptyText = (text) => {
  const isEmpty = text !== "" && text !== undefined && text !== null;
  return isEmpty ? text : "--";
};

// 检验统一社会信用代码
export const verifyUSCC = (code) => {
  return code.length !== 18 ? false : true;
};

/**
 * 创建 UUID（全局唯一标识符）
 * @return {String} 返回生成的 UUID
 */
export const createUuid = () => {
  return "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx".replace(/x/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const disposeOmitByObj = (data = {}) => {
  return omitBy(data, (item) => item === undefined || item === null);
};
/**
 * 生成file文件
 */
export const createFileData = (data) => {
  if (!data) return null;
  if (!Array.isArray(data)) return [];
  return data?.map((item) => {
    const fileData = {
      url: item,
      uuid: createUuid(),
      status: "done",
      name: item,
    };
    return fileData;
  });
};

/**
 * 创建集合File文件
 * @param {Array|string} data - 要创建的文件数据。可以是单个文件对象或文件路径的字符串，或者是包含多个文件对象或文件路径的数组。
 * @returns {Array|null} - 返回包含文件对象的数组，每个文件对象包括url、uuid、status和name属性；如果输入数据为空或无效，则返回null。
 */
export const createFilesData = (data) => {
  if (!data) return null;

  if (!Array.isArray(data)) {
    const fileData = {
      url: data?.url || data,
      uuid: createUuid(),
      status: "done",
      name: data?.name || data,
    };
    return [fileData];
  }

  return data.map((item) => {
    const fileData = {
      url: item?.url || item,
      uuid: createUuid(),
      status: "done",
      name: item?.name,
    };
    return fileData;
  });
};

export const AppTypeConfig = {
  1: {
    label: "集团",
    color: "#F5B300",
    backgroundColor: "#FFF9E8",
  },
  2: {
    label: "企业",
    color: "#1968E6",
    backgroundColor: "#E8F1FF",
  },
  3: {
    label: "基础",
    color: "#03BF8A",
    backgroundColor: "#E2F8F2",
  },
  4: {
    label: "园区",
    color: "#1968E6",
    backgroundColor: "#E8F1FF",
  },
};

// url下载自定义文件名
export const downloadUrlFile = (url, name) => {
  return fetch(url, {
    headers: {
      vecarbontoken: r.getToken(),
    },
  })
    .then((response) => response.blob())
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      // 设置文件名
      a.download = name;
      document.body.appendChild(a);
      a.click();
      setTimeout(() => {
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }, 100);
      return name;
    });
};

export function isSimpleEmpty(value) {
  return value === null || value === undefined || value === "" || value === [];
}

/**
 * 获取图片的宽和高
 * @param {*} file 文件对象
 * @returns
 */
export const getImageSize = (urls) => {
  if (!Array.isArray(urls)) {
    urls = [urls];
  }

  const promises = urls.map((url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const width = Math.ceil(img?.width || 0);
        const height = Math.ceil(img?.height || 0);
        const size = { width, height, url };
        resolve(size);
      };
      img.onerror = reject;
      img.src = url;
    });
  });

  return Promise.all(promises);
};
/**
 * 处理手机号中间四位变成****
 * @param {*} phoneNumber 手机号
 * @returns
 */
export const HidePhoneNumber = (phoneNumber) => {
  if (!phoneNumber) return;
  const hiddenNumber = `${phoneNumber.substr(0, 3)}****${phoneNumber.substr(
    7
  )}`;
  return <span>{hiddenNumber}</span>;
};
